import request from '@/utils/request'

// 查询列表
export function apiScpScDifferenceRatioList (query) {
  return request({
    url: '/scp/scpScDifferenceRatio/list',
    method: 'get',
    params: query
  })
}

// 新增
export function apiScpScDifferenceRatioSave (data) {
  return request({
    url: '/scp/scpScDifferenceRatio',
    method: 'post',
    data: data
  })
}

// 删除
export function apiScpScDifferenceRatioDelete (id) {
  return request({
    url: `/scp/scpScDifferenceRatio/${id}`,
    method: 'delete'
  })
}

// 修改
export function apiScpScDifferenceRatioUpdate (data) {
  return request({
    url: '/scp/scpScDifferenceRatio',
    method: 'put',
    data: data
  })
}
